import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO = "/home-hero.jpg";
const BTN = "shrink-0 inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 px-5 py-2.5 rounded-full font-medium transition-colors";

export const WelcomeHero = ({ user, ms, onJoin, testid = "home", joinTitle = false }) => {
  const member = ms?.current;
  const label = ms?.storico.length ? "Rinnova ora" : "Associati ora";
  const title = joinTitle ? `${user.nome}, ${label.toLowerCase()}` : `Ciao, ${user.nome}`;
  return (
    <section className="relative overflow-hidden rounded-2xl bg-[#0B192C] text-white mb-8 grain fade-up min-h-[320px] lg:min-h-[380px]" data-testid={`${testid}-hero`}>
      <img src={HERO} alt="Nacra 17 Italia in regata" data-testid={`${testid}-hero-image`} className="absolute inset-y-0 right-0 w-full lg:w-[62%] h-full object-cover object-[22%_center]" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B192C]/80 via-[#0B192C]/45 to-[#0B192C]/20 lg:bg-gradient-to-r lg:from-[#0B192C] lg:via-[#0B192C]/60 lg:to-transparent" />
      <div className="relative p-8 sm:p-12 max-w-xl">
        {!joinTitle && <div className="text-xs font-mono-x uppercase tracking-[0.2em] text-emerald-400 mb-3">Bentornato a bordo</div>}
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95]" data-testid={`${testid}-welcome-title`}>
          {title}
        </h1>
        {ms && !member && (
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4" data-testid={`${testid}-join-banner`}>
            <p className="text-slate-200">Non risulti ancora {user.genere === "Donna" ? "iscritta" : "iscritto"} per il {ms.anno}. {ms.storico.length ? "Rinnova" : "Associati"} per entrare nel libro soci.</p>
            {onJoin ? (
              <button onClick={onJoin} className={BTN} data-testid={`${testid}-join-button`}>{label} <ArrowRight className="h-4 w-4" /></button>
            ) : (
              <Link to="/tessera" className={BTN} data-testid={`${testid}-join-button`}>{label} <ArrowRight className="h-4 w-4" /></Link>
            )}
          </div>
        )}
        {member && <p className="mt-4 text-slate-200" data-testid={`${testid}-member-status`}>Socio {ms.anno} · Tessera <span className="font-mono-x">{member.tessera_numero}</span></p>}
      </div>
    </section>
  );
};
